import React, { forwardRef, useCallback } from 'react';
import { Transforms } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import './ChecklistItemElement.scss';

/** Slate checklist component for rich-text-editor
 *
 * Using forwardRef solves issue with resolving a Slate point from a DOM point caused by a mismatch between the position of the cursor in the DOM and the corresponding position in the Slate editor
 */
const ChecklistItemElement = forwardRef(({ attributes, children, element, readOnly }, ref) => {
  const editor = useSlateStatic();
  const { checked } = element;

  const handleCheck = useCallback(
    (event) => {
      const path = ReactEditor.findPath(editor, element);
      const newProperties = { checked: event.target.checked };
      Transforms.setNodes(editor, newProperties, { at: path });
    },
    [editor, element]
  );

  return (
    <div
      className='checklist-item-container'
      {...attributes}
    >
      <div
        className='checklist-item-input-span'
        contentEditable={false}
      >
        <input
          type='checkbox'
          checked={checked}
          onChange={handleCheck}
          ref={ref}
          disabled={readOnly}
        />
      </div>
      <span
        className='checklist-item-label-span'
        suppressContentEditableWarning
      >
        {children}
      </span>
    </div>
  );
});

ChecklistItemElement.displayName = 'ChecklistItemElement';
export default ChecklistItemElement;
